/**
 * Onde mora o Aviso de Privacidade da plataforma.
 *
 * Só o CAMINHO, nunca a URL inteira: o domínio muda entre desenvolvimento e
 * produção, e uma constante com `https://…` cravado mandaria o participante de
 * um ambiente de teste para o site de verdade — ou pior, o contrário, colhendo
 * consentimento contra um texto que não é o daquele ambiente.
 *
 * Quem prefixa é cada lado com o que ele sabe: a API usa `WEB_URL`, o painel usa
 * `window.location.origin`.
 *
 * Arquivo próprio, e não dentro do `index.ts`, porque o Vite mapeia
 * `@mpa/shared/<subcaminho>` um a um (ver `apps/web/vite.config.ts`): o pacote
 * inteiro não entra no bundle da SPA, e é assim de propósito.
 *
 * Os TRÊS lugares que precisam concordar sobre este caminho importam daqui — a
 * rota da SPA, o campo de Configurações e o padrão do envio. Um literal a mais
 * em qualquer um deles é uma página 404 dentro de uma mensagem de
 * consentimento.
 */
export const CAMINHO_AVISO_PRIVACIDADE = '/privacidade';

/** A URL completa, dado o endereço em que aquele ambiente responde. */
export function avisoDePrivacidadeEm(base: string): string {
  return `${base.replace(/\/+$/, '')}${CAMINHO_AVISO_PRIVACIDADE}`;
}
